
export const SET_FIRE_LOAD = "SET_FIRE_LOAD";
export function action_setFireLoad(loadFire) { return { type: SET_FIRE_LOAD, payload: loadFire }; }

export const SET_NOTIFICATION_TASKS_LIST = "SET_NOTIFICATION_TASKS_LIST";
export function action_setNotificacionTaskList(list) { return { type: SET_NOTIFICATION_TASKS_LIST, payload: list }; }

export const SET_NOTIFICATION_TASKS_LIST_FILTRED = "SET_NOTIFICATION_TASKS_LIST_FILTRED";
export function action_setNotificacionTaskListFiltred(filtredList) { return { type: SET_NOTIFICATION_TASKS_LIST_FILTRED, payload: filtredList }; }

export const SET_NOTIFICATION_TASKS_FOCUSEDITEM = "SET_NOTIFICATION_TASKS_FOCUSEDITEM";
export function action_setNotificacionTaskFocusedItem(focusedItems) { return { type: SET_NOTIFICATION_TASKS_FOCUSEDITEM, payload: focusedItems }; }

export const SET_NOTIFICATION_TASKS_SELECTEDITEMS = "SET_NOTIFICATION_TASKS_SELECTEDITEMS";
export function action_setNotificacionTaskSelectedItems(selectedItems) { return { type: SET_NOTIFICATION_TASKS_SELECTEDITEMS, payload: selectedItems }; }

export const SET_NOTIFICATION_TASKS_MENUITEMS = "SET_NOTIFICATION_TASKS_MENUITEMS";
export function action_setNotificacionTaskMenuItems(menuItems) { return { type: SET_NOTIFICATION_TASKS_MENUITEMS, payload: menuItems }; }
